import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import Swal from 'sweetalert2';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class SmartwatchSummaryStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      summaryHeartrate: {},
      summarySpo2: {},
      summaryRespiration: {},
      dailyHeartrateData: [],
      dailySpo2Data: [],
      dailyRespirationData: [],
      includeDate: [],
      normalDate: [],
      notNormalDate: [],
      loading: false,
    });
  }

  async exportGarmin(patientId, type, startdate, enddate, fullname) {
    this.loading = true;

    try {
      const url = `${config.api.url}/${config.api.version}/smartwatch/garmin/summary/export/patient/${patientId}?type=[${type}]&startDate=${startdate}&endDate=${enddate}&fullname=${fullname}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res.statusCode === 200) {
        if (res.body.message === 'No data available') {
          Swal.fire({
            html: `<h4>No data available`,
            type: 'warning',
            confirmButtonColor: '#007D79',
            customClass: {
              container: 'my-swal',
            },
          });
          return;
        } else {
          console.log(url);
          window.open(url);
        }
        // console.log(res.body);
        // console.log(res.body.message);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async summaryVitalSigns(patientId, date, viewType, vitalSignTypes) {
    this.loading = true;
    const dateFormat = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(
      -2,
    )}-${('0' + date.getDate()).slice(-2)}`;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/garmin/summary/vitalsign/${patientId}/date/${dateFormat}`;
      const res = await rp
        .get(url, {
          qs: {
            as: viewType,
            type: JSON.stringify(vitalSignTypes),
          },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const datas = res.body || null;
        if (viewType === 'daily') {
          if (datas.heartrate) {
            this.dailyHeartrateData = datas.heartrate.hasOwnProperty('heartrateData')
              ? datas.heartrate['heartrateData']
              : [];
          }
          if (datas.spo2) {
            this.dailySpo2Data = datas.spo2.hasOwnProperty('spo2Data') ? datas.spo2['spo2Data'] : [];
          }
          if (datas.respiration) {
            this.dailyRespirationData = datas.respiration.hasOwnProperty('respirationData')
              ? datas.respiration['respirationData']
              : [];
          }
        } else {
          // this.summaryHeartrate = this.calcHeartRatesChart(datas, dateFormat, viewType);
          // this.summaryHeartrate = this.calcVitalSignsChart(datas, dateFormat, viewType, vitalSignTypes);
          if (datas.heartrate) {
            this.summaryHeartrate = this.calcVitalSignsChart(datas, dateFormat, viewType, 'heartrate');
          }
          if (datas.spo2) {
            this.summarySpo2 = this.calcVitalSignsChart(datas, dateFormat, viewType, 'spo2');
          }
          if (datas.respiration) {
            this.summaryRespiration = this.calcVitalSignsChart(datas, dateFormat, viewType, 'respiration');
          }
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  calcVitalSignsChart(datas, date, viewType, vitalSignType) {
    const average = [];
    const resting = [];
    const minmax = [];

    // re-format datas
    if (vitalSignType === 'heartrate') {
      (datas.heartrate || []).forEach((d) => {
        if (viewType === 'yearly') {
          average.push(
            this.reformatData(d.month, d.month, Math.round(d.averageHeartRateInBeatsPerMinute / d.noOfDate)),
          );
          resting.push(
            this.reformatData(d.month, d.month, Math.round(d.restingHeartRateInBeatsPerMinute / d.noOfDate)),
          );

          const hasMin = true;
          // d.minHeartRateInBeatsPerMinute !==
          // d.averageHeartRateInBeatsPerMinute;
          const hasMax = true;
          // d.maxHeartRateInBeatsPerMinute !==
          // d.averageHeartRateInBeatsPerMinute;
          minmax.push(
            this.reformatMinMaxData(
              d.month,
              d.month,
              hasMin ? Math.round(d.minHeartRateInBeatsPerMinute / d.noOfDate) : null,
              hasMax ? Math.round(d.maxHeartRateInBeatsPerMinute / d.noOfDate) : null,
            ),
          );
        } else {
          const dt = new Date(d.createdDate);
          const createdDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
            -2,
          )}-${('0' + dt.getDate()).slice(-2)}`;
          average.push(this.reformatData(createdDate, d.createdDate, d.averageHeartRateInBeatsPerMinute));
          resting.push(this.reformatData(createdDate, d.createdDate, d.restingHeartRateInBeatsPerMinute));

          const hasMin = true;
          // d.minHeartRateInBeatsPerMinute !==
          // d.averageHeartRateInBeatsPerMinute;
          const hasMax = true;
          // d.maxHeartRateInBeatsPerMinute !==
          // d.averageHeartRateInBeatsPerMinute;
          minmax.push(
            this.reformatMinMaxData(
              createdDate,
              d.createdDate,
              hasMin ? d.minHeartRateInBeatsPerMinute : null,
              hasMax ? d.maxHeartRateInBeatsPerMinute : null,
            ),
          );
        }
      });

      const dateTimes =
        viewType === 'yearly'
          ? this.getMonths(date, 12)
          : viewType === 'monthly'
            ? this.getDays(date, 30)
            : this.getDays(date, 7);
      return {
        average: this.calcDataForPeriod(average, dateTimes),
        resting: this.calcDataForPeriod(resting, dateTimes),
        minmax: this.calcDataForPeriod(minmax, dateTimes, true),
      };
    } else if (vitalSignType === 'spo2') {
      (datas.spo2 || []).forEach((d) => {
        if (viewType === 'yearly') {
          average.push(this.reformatData(d.month, d.month, Math.round(d.averageSpo2 / d.noOfDate)));

          const hasMin = true; //d.minSpo2 !== d.averageSpo2;
          const hasMax = true; //d.maxSpo2 !== d.averageSpo2;
          minmax.push(
            this.reformatMinMaxData(
              d.month,
              d.month,
              hasMin ? Math.round(d.minSpo2 / d.noOfDate) : null,
              hasMax ? Math.round(d.maxSpo2 / d.noOfDate) : null,
            ),
          );
        } else {
          const dt = new Date(d.createdDate);
          const createdDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
            -2,
          )}-${('0' + dt.getDate()).slice(-2)}`;
          average.push(this.reformatData(createdDate, d.createdDate, d.averageSpo2));

          const hasMin = true; //d.minSpo2 !== d.averageSpo2;
          const hasMax = true; //d.maxSpo2 !== d.averageSpo2;
          minmax.push(
            this.reformatMinMaxData(createdDate, d.createdDate, hasMin ? d.minSpo2 : null, hasMax ? d.maxSpo2 : null),
          );
        }
      });

      const dateTimes =
        viewType === 'yearly'
          ? this.getMonths(date, 12)
          : viewType === 'monthly'
            ? this.getDays(date, 30)
            : this.getDays(date, 7);
      return {
        average: this.calcDataForPeriod(average, dateTimes),
        minmax: this.calcDataForPeriod(minmax, dateTimes, true),
      };
    } else if (vitalSignType === 'respiration') {
      (datas.respiration || []).forEach((d) => {
        if (viewType === 'yearly') {
          average.push(this.reformatData(d.month, d.month, Math.round(d.averageRespiration / d.noOfDate)));

          const hasMin = true; //d.minRespiration !== d.averageRespiration;
          const hasMax = true; //d.maxRespiration !== d.averageRespiration;
          minmax.push(
            this.reformatMinMaxData(
              d.month,
              d.month,
              hasMin ? Math.round(d.minRespiration / d.noOfDate) : null,
              hasMax ? Math.round(d.maxRespiration / d.noOfDate) : null,
            ),
          );
        } else {
          const dt = new Date(d.createdDate);
          const createdDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
            -2,
          )}-${('0' + dt.getDate()).slice(-2)}`;
          average.push(this.reformatData(createdDate, d.createdDate, d.averageRespiration));

          const hasMin = true; //d.minRespiration !== d.averageRespiration;
          const hasMax = true; //d.maxRespiration !== d.averageRespiration;
          minmax.push(
            this.reformatMinMaxData(
              createdDate,
              d.createdDate,
              hasMin ? d.minRespiration : null,
              hasMax ? d.maxRespiration : null,
            ),
          );
        }
      });

      const dateTimes =
        viewType === 'yearly'
          ? this.getMonths(date, 12)
          : viewType === 'monthly'
            ? this.getDays(date, 30)
            : this.getDays(date, 7);
      return {
        average: this.calcDataForPeriod(average, dateTimes),
        minmax: this.calcDataForPeriod(minmax, dateTimes, true),
      };
    }

    return null;
  }

  reformatData(refDate, date, data) {
    const dt = new Date(date);
    return {
      date: refDate,
      value: [this.getUTCDateTime(dt), data],
    };
  }

  reformatMinMaxData(refDate, date, dataMin, dataMax) {
    const dt = new Date(date);
    return {
      date: refDate,
      value: [this.getUTCDateTime(dt), dataMin, dataMax],
    };
  }

  calcDataForPeriod = (datas, dateTimes, minmax = false) => {
    const results = dateTimes.map((date) => {
      const found = datas.find((d) => d.date === date);
      if (minmax) {
        return found ? found.value : [this.getUTCDateTime(new Date(date)), null, null];
      }
      return found ? found.value : [this.getUTCDateTime(new Date(date)), null];
    });

    return results.sort();
  };

  getUTCDateTime(dateTime) {
    return dateTime.getTime() - dateTime.getTimezoneOffset() * 60 * 1000;
  }

  getDays = (date, days) => {
    const results = [];
    for (let i = 0; i < days; i++) {
      let d = new Date(date);
      d.setDate(d.getDate() - i);
      const tmp = `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
      results.push(tmp);
    }
    return results;
  };

  getMonths = (date, months) => {
    const results = [];
    for (let i = 0; i < months; i++) {
      let d = new Date(date);
      d.setMonth(d.getMonth() - i);
      const tmp = `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}`;
      results.push(tmp);
    }
    return results;
  };
}
export default new SmartwatchSummaryStore();
